import { render } from "./Home.vue?vue&type=template&id=58678e4e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=58678e4e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58678e4e"]])

export default __exports__